module.exports = __webpack_public_path__ + "assets/1270a83e7d4bcc315824be51518c3596.svg";